/** @jsx jsx */
import { jsx } from '@front10/base-elements';
import React from 'react';
import WeekDay from './WeekDay';
import MonthCaption from './MonthCaption';
import { InternalEvent, MonthHandler } from '../types';
import DayItem from './DayItem';
import DayItemMobile from './DayItemMobile';
import { FnOnDayClick, FnOnDayHover } from './hooks';
import { Box } from '@front10/base-elements';
import { useWeekDays } from '../i18n';
import isSameDay from 'date-fns/isSameDay';

export type MonthItemProps = {
  captionItem: unknown;
  month: MonthHandler;
  weekdayItem: unknown;
  dayItems: unknown;
  renderDay?: Function;
  onDayClick: FnOnDayClick;
  onDayHover?: FnOnDayHover;
  showYear?: boolean;
  showWeekDayNames?: boolean;
  isMobile?: boolean;
  preSelectedDate?: Date;
  weekDaysContainer?: any;
  calendarMonthContainer?: $TSFixMe;
  setWasOpenPopup?: (value: boolean) => void;
  events?: InternalEvent[];
};
const MonthItem = (
  {
    captionItem,
    month,
    weekdayItem,
    dayItems,
    onDayHover = () => {},
    renderDay,
    onDayClick = () => {},
    showYear,
    showWeekDayNames = true,
    weekDaysContainer,
    calendarMonthContainer,
    setWasOpenPopup,
    isMobile = false,
    events
  }: MonthItemProps,
  ref: any
) => {
  const Tag = isMobile ? DayItemMobile : DayItem;
  const days = React.useMemo(() => month.getMonthData(), [month]);
  const weekdays = useWeekDays();

  const renderWeekDayNames = showWeekDayNames && (
    <tr
      className="calendar-days-title"
      {...weekDaysContainer}
      sx={{ borderBottom: 'solid 1px', borderColor: 'colorBorders' }}
    >
      {weekdays.map((offset) => {
        return (
          <WeekDay
            key={`month-${month.getMonth()}-${offset}`}
            weekday={offset}
            {...weekdayItem}
            sx={{ py: 2, mb: 2 }}
          />
        );
      })}
    </tr>
  );
  let renderWeeks;
  if (renderDay) {
    renderWeeks = days.map((week, i) => (
      <Box className="calendar-week" key={`month-${month}-${i}`} role="row">
        {week.map((dayData, index) => {
          return renderDay({ dayData, index, onDayClick, onDayHover, dayItems });
        })}
      </Box>
    ));
  } else {
    renderWeeks = days.map((week, i) => {
      const showWeek = week.findIndex((e) => e?.modifiers?.disabled === false) !== -1;
      if (!showWeek) {
        return null;
      }
      return (
        <Box className="calendar-week" key={`month-${month}-${i}`} as="tr">
          {week.map((day, index) => {
            const dayEvents = events?.filter((event) => isSameDay(event.date, day.date));
            return (
              <Tag
                {...dayItems}
                dayData={day}
                onDayClick={onDayClick}
                onDayHover={onDayHover}
                key={`${day?.date?.getDate()}-${day?.date?.getMonth()}-${index}`}
                setWasOpenPopup={setWasOpenPopup}
                events={dayEvents}
              />
            );
          })}
        </Box>
      );
    });
  }

  return (
    <Box
      className="calendar-month-container"
      {...calendarMonthContainer}
      key={`month-${month.getMonth().getMonth()}`}
      focusReferences={ref}
      px={3}
    >
      <Box
        as="table"
        className="calendar-month"
        sx={{ width: 'min-content !important', margin: 'auto' }}
      >
        <thead>
          {renderWeekDayNames}
          <tr>
            <th colSpan={7}>
              <MonthCaption date={month.getMonth()} {...captionItem} showYear={showYear} />
            </th>
          </tr>
        </thead>
        <tbody>{renderWeeks}</tbody>
      </Box>
    </Box>
  );
};
export default React.forwardRef(MonthItem);
